import PropTypes from 'prop-types'

import MiniCloud from '../../../images/pages/appdynamics/appdynamics-mini-cloud.png'

export const NodeInsights = ({ className, classNames }) => (
  <div className={classNames.container}>
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="630"
      height="625"
      viewBox="0 0 630 625"
    >
      <defs>
        <rect id="appdynamics-node-insights-b" width="226" height="69" rx="4" />
        <filter
          id="appdynamics-node-insights-a"
          width="159.7%"
          height="295.7%"
          x="-29.9%"
          y="-76.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="15" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="20" />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          />
        </filter>
        <filter
          id="appdynamics-node-insights-c"
          width="170.8%"
          height="170.8%"
          x="-35.4%"
          y="-35.4%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="17" />
        </filter>
        <linearGradient
          id="appdynamics-node-insights-d"
          x1="12.453%"
          x2="87.895%"
          y1="84.924%"
          y2="16.33%"
        >
          <stop offset="0%" stopColor="#1D8DBA" />
          <stop offset="100%" stopColor="#03ECAE" />
        </linearGradient>
        <filter
          id="appdynamics-node-insights-e"
          width="231.2%"
          height="231.2%"
          x="-65.6%"
          y="-65.6%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="21" />
        </filter>
        <linearGradient
          id="appdynamics-node-insights-f"
          x1="46.145%"
          x2="28.402%"
          y1="50%"
          y2="50%"
        >
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-g"
          x1="68.806%"
          x2="36.458%"
          y1="66.97%"
          y2="37.782%"
        >
          <stop offset="0%" stopColor="#00EBAD" />
          <stop offset="100%" stopColor="#1D8DBA" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-h" x1="100%" x2="-.347%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-i" x1="0%" y1="50.011%" y2="50.011%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-j"
          x1="44.246%"
          x2="28.931%"
          y1="50.008%"
          y2="50.008%"
        >
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-k"
          x1="67.366%"
          x2="37.646%"
          y1="67.526%"
          y2="37.522%"
        >
          <stop offset="0%" stopColor="#00EBAD" />
          <stop offset="100%" stopColor="#1D8DBA" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-l"
          x1="64.366%"
          x2="41.792%"
          y1="64.261%"
          y2="41.848%"
        >
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" stopOpacity=".6" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-m"
          x1="99.289%"
          x2=".312%"
          y1="50.011%"
          y2="50.011%"
        >
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-n" x1="43.8%" x2="22.503%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-o"
          x1="67.161%"
          x2="37.643%"
          y1="67.568%"
          y2="37.343%"
        >
          <stop offset="0%" stopColor="#00EBAD" />
          <stop offset="100%" stopColor="#1D8DBA" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-p" x1="98.751%" x2="-.035%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-q" x1="33.16%" x2="-.321%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-r"
          x1="68.384%"
          x2="37.045%"
          y1="67.523%"
          y2="37.644%"
        >
          <stop offset="0%" stopColor="#00EBAD" />
          <stop offset="100%" stopColor="#1D8DBA" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-s" x1="98.751%" x2=".555%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-t" x1="39.169%" x2="2.185%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-u"
          x1="67.699%"
          x2="37.704%"
          y1="67.678%"
          y2="37.714%"
        >
          <stop offset="0%" stopColor="#00EBAD" />
          <stop offset="100%" stopColor="#1D8DBA" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-v" x1="97.086%" x2=".225%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-w" x1="39.421%" x2="8.437%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-x"
          x1="65.713%"
          x2="38.883%"
          y1="68.349%"
          y2="37.023%"
        >
          <stop offset="0%" stopColor="#00EBAD" />
          <stop offset="100%" stopColor="#1D8DBA" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-y"
          x1="60.9%"
          x2="42.421%"
          y1="59.143%"
          y2="43.645%"
        >
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" stopOpacity=".6" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-z"
          x1="98.231%"
          x2=".451%"
          y1="49.989%"
          y2="49.989%"
        >
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-A" x1="38.857%" x2=".477%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-B"
          x1="68.939%"
          x2="36.793%"
          y1="67.463%"
          y2="37.819%"
        >
          <stop offset="0%" stopColor="#00EBAD" />
          <stop offset="100%" stopColor="#1D8DBA" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-C"
          x1="98.751%"
          x2=".052%"
          y1="49.989%"
          y2="49.989%"
        >
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-D" x1="43.453%" x2=".911%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="100%" stopColor="#162A40" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-E"
          x1="67.525%"
          x2="37.4%"
          y1="67.042%"
          y2="37.744%"
        >
          <stop offset="0%" stopColor="#00EBAD" />
          <stop offset="100%" stopColor="#1D8DBA" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-F"
          x1="57.9%"
          x2="41.944%"
          y1="59.192%"
          y2="40.628%"
        >
          <stop offset="0%" stopColor="#162A40" stopOpacity="0" />
          <stop offset="42%" stopColor="#162A40" stopOpacity=".28" />
          <stop offset="100%" stopColor="#162A40" stopOpacity=".6" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-G" x1="98.006%" x2=".139%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="25%" stopColor="#FFF" stopOpacity=".01" />
          <stop offset="47%" stopColor="#FFF" stopOpacity=".06" />
          <stop offset="68%" stopColor="#FFF" stopOpacity=".13" />
          <stop offset="88%" stopColor="#FFF" stopOpacity=".23" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-H" x1="0%" y1="50.008%" y2="50.008%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="12%" stopColor="#FFF" stopOpacity=".02" />
          <stop offset="24%" stopColor="#FFF" stopOpacity=".07" />
          <stop offset="37%" stopColor="#FFF" stopOpacity=".15" />
          <stop offset="50%" stopColor="#FFF" stopOpacity=".26" />
          <stop offset="63%" stopColor="#FFF" stopOpacity=".41" />
          <stop offset="76%" stopColor="#FFF" stopOpacity=".6" />
          <stop offset="89%" stopColor="#FFF" stopOpacity=".81" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-I" x1="0%" y1="49.948%" y2="49.948%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="12%" stopColor="#FFF" stopOpacity=".02" />
          <stop offset="24%" stopColor="#FFF" stopOpacity=".07" />
          <stop offset="37%" stopColor="#FFF" stopOpacity=".15" />
          <stop offset="50%" stopColor="#FFF" stopOpacity=".26" />
          <stop offset="63%" stopColor="#FFF" stopOpacity=".41" />
          <stop offset="76%" stopColor="#FFF" stopOpacity=".6" />
          <stop offset="89%" stopColor="#FFF" stopOpacity=".81" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-J" x1="0%" y1="49.942%" y2="49.942%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="12%" stopColor="#FFF" stopOpacity=".02" />
          <stop offset="24%" stopColor="#FFF" stopOpacity=".07" />
          <stop offset="37%" stopColor="#FFF" stopOpacity=".15" />
          <stop offset="50%" stopColor="#FFF" stopOpacity=".26" />
          <stop offset="63%" stopColor="#FFF" stopOpacity=".41" />
          <stop offset="76%" stopColor="#FFF" stopOpacity=".6" />
          <stop offset="89%" stopColor="#FFF" stopOpacity=".81" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-K" x1="0%" y1="49.932%" y2="49.932%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="12%" stopColor="#FFF" stopOpacity=".02" />
          <stop offset="24%" stopColor="#FFF" stopOpacity=".07" />
          <stop offset="37%" stopColor="#FFF" stopOpacity=".15" />
          <stop offset="50%" stopColor="#FFF" stopOpacity=".26" />
          <stop offset="63%" stopColor="#FFF" stopOpacity=".41" />
          <stop offset="76%" stopColor="#FFF" stopOpacity=".6" />
          <stop offset="89%" stopColor="#FFF" stopOpacity=".81" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-L" x1="0%" y1="49.996%" y2="49.996%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="12%" stopColor="#FFF" stopOpacity=".02" />
          <stop offset="24%" stopColor="#FFF" stopOpacity=".07" />
          <stop offset="37%" stopColor="#FFF" stopOpacity=".15" />
          <stop offset="50%" stopColor="#FFF" stopOpacity=".26" />
          <stop offset="63%" stopColor="#FFF" stopOpacity=".41" />
          <stop offset="76%" stopColor="#FFF" stopOpacity=".6" />
          <stop offset="89%" stopColor="#FFF" stopOpacity=".81" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-M" x1="0%" y1="50.038%" y2="50.038%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="12%" stopColor="#FFF" stopOpacity=".02" />
          <stop offset="24%" stopColor="#FFF" stopOpacity=".07" />
          <stop offset="37%" stopColor="#FFF" stopOpacity=".15" />
          <stop offset="50%" stopColor="#FFF" stopOpacity=".26" />
          <stop offset="63%" stopColor="#FFF" stopOpacity=".41" />
          <stop offset="76%" stopColor="#FFF" stopOpacity=".6" />
          <stop offset="89%" stopColor="#FFF" stopOpacity=".81" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-N" x1="0%" y1="49.956%" y2="49.956%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="12%" stopColor="#FFF" stopOpacity=".02" />
          <stop offset="24%" stopColor="#FFF" stopOpacity=".07" />
          <stop offset="37%" stopColor="#FFF" stopOpacity=".15" />
          <stop offset="50%" stopColor="#FFF" stopOpacity=".26" />
          <stop offset="63%" stopColor="#FFF" stopOpacity=".41" />
          <stop offset="76%" stopColor="#FFF" stopOpacity=".6" />
          <stop offset="89%" stopColor="#FFF" stopOpacity=".81" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="appdynamics-node-insights-O" x1="0%" y1="50.008%" y2="50.008%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="12%" stopColor="#FFF" stopOpacity=".02" />
          <stop offset="24%" stopColor="#FFF" stopOpacity=".07" />
          <stop offset="37%" stopColor="#FFF" stopOpacity=".15" />
          <stop offset="50%" stopColor="#FFF" stopOpacity=".26" />
          <stop offset="63%" stopColor="#FFF" stopOpacity=".41" />
          <stop offset="76%" stopColor="#FFF" stopOpacity=".6" />
          <stop offset="89%" stopColor="#FFF" stopOpacity=".81" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <filter
          id="appdynamics-node-insights-P"
          width="206.2%"
          height="206.2%"
          x="-53.1%"
          y="-53.1%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="17" />
        </filter>
        <linearGradient
          id="appdynamics-node-insights-Q"
          x1="12.453%"
          x2="87.895%"
          y1="60.636%"
          y2="39.746%"
        >
          <stop offset="0%" stopColor="#1D8DBA" />
          <stop offset="100%" stopColor="#03ECAE" />
        </linearGradient>
        <linearGradient
          id="appdynamics-node-insights-R"
          x1="12.453%"
          x2="87.895%"
          y1="63.976%"
          y2="36.526%"
        >
          <stop offset="0%" stopColor="#1D8DBA" />
          <stop offset="100%" stopColor="#03ECAE" />
        </linearGradient>
        <rect id="appdynamics-node-insights-T" width="226" height="238" x="213" y="49" rx="4" />
        <filter
          id="appdynamics-node-insights-S"
          width="177.4%"
          height="173.5%"
          x="-38.7%"
          y="-26.3%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="25" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          />
        </filter>
        <filter
          id="appdynamics-node-insights-U"
          width="127.3%"
          height="5049.9%"
          x="-13.7%"
          y="-2474.9%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="7" />
        </filter>
        <filter
          id="appdynamics-node-insights-V"
          width="600%"
          height="2500%"
          x="-250%"
          y="-1212.5%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="7" />
        </filter>
        <filter
          id="appdynamics-node-insights-W"
          width="127.3%"
          height="5049.9%"
          x="-13.7%"
          y="-2474.9%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="7" />
        </filter>
        <filter
          id="appdynamics-node-insights-X"
          width="256.2%"
          height="2500%"
          x="-78.1%"
          y="-1212.5%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="7" />
        </filter>
        <filter
          id="appdynamics-node-insights-Y"
          width="127.3%"
          height="5049.9%"
          x="-13.7%"
          y="-2474.9%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="7" />
        </filter>
        <rect id="appdynamics-node-insights-aa" width="242" height="173" rx="4" />
        <filter
          id="appdynamics-node-insights-Z"
          width="172.3%"
          height="201.2%"
          x="-36.2%"
          y="-36.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="25" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          />
        </filter>
        <filter
          id="appdynamics-node-insights-ab"
          width="140.4%"
          height="1900%"
          x="-20.2%"
          y="-912.5%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>
        <filter
          id="appdynamics-node-insights-ac"
          width="642.9%"
          height="1900%"
          x="-271.4%"
          y="-912.5%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>
        <filter
          id="appdynamics-node-insights-ad"
          width="1366.7%"
          height="1900%"
          x="-633.3%"
          y="-912.5%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>
        <filter
          id="appdynamics-node-insights-ae"
          width="3900%"
          height="1900%"
          x="-1900%"
          y="-912.5%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>
        <filter
          id="appdynamics-node-insights-af"
          width="1366.7%"
          height="3800%"
          x="-633.3%"
          y="-1850%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(50)">
        <g
          stroke="#00D180"
          strokeDasharray="5"
          strokeLinecap="square"
          transform="translate(53.75 42.5)"
        >
          <line x1="254.75" x2="366.75" y2="312" />
          <line x1="84.75" x2="312.75" y1="178" y2="441" />
          <line x1="84.75" x2="436.75" y1="139" y2="262" />
          <line x1="20.75" x2=".75" y1="190" y2="317" />
        </g>
        <g transform="translate(166 68)">
          <use
            fill="#000"
            filter="url(#appdynamics-node-insights-a)"
            xlinkHref="#appdynamics-node-insights-b"
          />
          <use fill="#F7FBFB" xlinkHref="#appdynamics-node-insights-b" />
          <polygon
            fill="#48A7C7"
            fillOpacity=".372"
            stroke="#1883A6"
            points="13.656 50.328 26.996 48.229 40.005 51.788 70.782 50.008 87.055 52.555 105.338 43.267 119.63 53.48 150.647 41.985 174.541 48.229 193.734 35.438 208.367 50.794 218.541 50.794 219.298 59.388 12.712 59.16"
          />
          <line
            x1="14.5"
            x2="218.5"
            y1="21.5"
            y2="21.5"
            stroke="#979797"
            strokeLinecap="square"
            opacity=".19"
          />
          <line
            x1="14.5"
            x2="218.5"
            y1="43.5"
            y2="43.5"
            stroke="#979797"
            strokeLinecap="square"
            opacity=".19"
          />
        </g>
        <g transform="translate(20 101)">
          <circle
            cx="72"
            cy="72"
            r="72"
            fill="#04EAAE"
            filter="url(#appdynamics-node-insights-c)"
            opacity=".567"
          />
          <circle cx="72" cy="72" r="72" fill="#04EAAE" />
          <circle
            cx="72"
            cy="72"
            r="54"
            fill="url(#appdynamics-node-insights-d)"
            stroke="#FFF"
            strokeWidth="4.5"
          />
          <text fill="#FFF" fontFamily="Arial-BoldMT, Arial" fontSize="16.5" fontWeight="bold">
            <tspan x="63.279" y="44">
              11
            </tspan>{' '}
            <tspan x="80.721" y="44" fontFamily="ArialMT, Arial" fontSize="12" fontWeight="normal">
              {' '}
            </tspan>{' '}
            <tspan x="54.331" y="62" fontFamily="ArialMT, Arial" fontSize="12" fontWeight="normal">
              TIERS
            </tspan>
          </text>
          <text fill="#FFF" fontFamily="Arial-BoldMT, Arial" fontSize="16.5" fontWeight="bold">
            <tspan x="62.323" y="98">
              15{' '}
            </tspan>{' '}
            <tspan x="50.163" y="116" fontFamily="ArialMT, Arial" fontSize="12" fontWeight="normal">
              NODES
            </tspan>
          </text>
        </g>
        <g transform="translate(343 466)">
          <circle cx="48" cy="48" r="48" fill="#04EAAE" />
          <circle
            cx="48"
            cy="48"
            r="48"
            fill="#04EAAE"
            filter="url(#appdynamics-node-insights-e)"
            opacity=".538"
          />
          <circle
            cx="48"
            cy="48"
            r="36"
            fill="url(#appdynamics-node-insights-d)"
            stroke="#FFF"
            strokeWidth="3"
          />
        </g>
        <g transform="translate(358 489)">
          <polygon
            fill="#097496"
            points="48.548 26.718 35.899 19.415 35.899 16.337 48.548 12.112 61.195 16.337 61.195 19.415"
          />
          <polygon
            fill="url(#appdynamics-node-insights-f)"
            points="48.548 26.718 35.899 19.415 35.899 16.337 48.548 12.112 61.195 16.337 61.195 19.415"
          />
          <polygon
            fill="url(#appdynamics-node-insights-g)"
            points="48.548 23.64 35.899 16.337 48.548 9.034 61.195 16.337"
          />
          <image
            width="38.829"
            height="29.177"
            y=".197"
            opacity=".6"
            transform="translate(29.177 1.536)"
            xlinkHref={MiniCloud}
          />
          <polygon fill="#1D8DBA" points="48.548 23.64 48.548 26.718 61.195 19.415 61.195 16.337" />
          <polygon
            fill="url(#appdynamics-node-insights-h)"
            points="48.548 23.64 48.548 26.718 61.195 19.415 61.195 16.337"
          />
          <polygon
            fill="url(#appdynamics-node-insights-i)"
            points="48.548 18.805 48.548 21.88 61.195 14.577 61.195 11.502"
          />
          <polygon
            fill="#097496"
            points="48.548 21.88 35.899 14.577 35.899 11.502 48.548 7.277 61.195 11.502 61.195 14.577"
          />
          <polygon
            fill="url(#appdynamics-node-insights-j)"
            points="48.548 21.88 35.899 14.577 35.899 11.502 48.548 7.277 61.195 11.502 61.195 14.577"
          />
          <polygon
            fill="url(#appdynamics-node-insights-k)"
            points="48.548 18.805 35.899 11.502 48.548 4.199 61.195 11.502"
          />
          <polygon
            fill="url(#appdynamics-node-insights-l)"
            points="48.548 18.805 35.899 11.502 48.548 4.199 61.195 11.502"
          />
          <polygon fill="#1D8DBA" points="48.548 18.805 48.548 21.88 61.195 14.577 61.195 11.502" />
          <polygon
            fill="url(#appdynamics-node-insights-m)"
            points="48.548 18.805 48.548 21.88 61.195 14.577 61.195 11.502"
          />
          <polygon
            fill="#097496"
            points="33.863 35.212 21.214 27.909 21.214 24.831 33.863 20.606 46.512 24.831 46.512 27.909"
          />
          <polygon
            fill="url(#appdynamics-node-insights-n)"
            points="33.863 35.212 21.214 27.909 21.214 24.831 33.863 20.606 46.512 24.831 46.512 27.909"
          />
          <polygon
            fill="url(#appdynamics-node-insights-o)"
            points="33.863 32.134 21.214 24.831 33.863 17.53 46.512 24.831"
          />
          <image
            width="38.391"
            height="28.957"
            y=".197"
            opacity=".6"
            transform="translate(14.698 10.091)"
            xlinkHref="data:image/png;base64,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"
          />
          <polygon
            fill="#1D8DBA"
            points="33.863 32.134 33.863 35.212 46.512 27.909 46.512 24.831"
          />
          <polygon
            fill="url(#appdynamics-node-insights-p)"
            points="33.863 32.134 33.863 35.212 46.512 27.909 46.512 24.831"
          />
          <polygon
            fill="#097496"
            points="33.863 30.377 21.214 23.074 21.214 19.996 33.863 15.771 46.512 19.996 46.512 23.074"
          />
          <polygon
            fill="url(#appdynamics-node-insights-q)"
            points="33.863 30.377 21.214 23.074 21.214 19.996 33.863 15.771 46.512 19.996 46.512 23.074"
          />
          <polygon
            fill="url(#appdynamics-node-insights-r)"
            points="33.863 27.299 21.214 19.996 33.863 12.693 46.512 19.996"
          />
          <polygon
            fill="#1D8DBA"
            points="33.863 27.299 33.863 30.377 46.512 23.074 46.512 19.996"
          />
          <polygon
            fill="url(#appdynamics-node-insights-s)"
            points="33.863 27.299 33.863 30.377 46.512 23.074 46.512 19.996"
          />
          <polygon
            fill="#097496"
            points="19.18 43.631 6.531 36.328 6.531 33.251 19.18 29.026 31.829 33.251 31.829 36.328"
          />
          <polygon
            fill="url(#appdynamics-node-insights-t)"
            points="19.18 43.631 6.531 36.328 6.531 33.251 19.18 29.026 31.829 33.251 31.829 36.328"
          />
          <polygon
            fill="url(#appdynamics-node-insights-u)"
            points="19.18 40.554 6.531 33.251 19.18 25.948 31.829 33.251"
          />
          <image
            width="38.391"
            height="28.957"
            y=".197"
            opacity=".6"
            transform="translate(0 18.427)"
            xlinkHref="data:image/png;base64,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"
          />
          <polygon fill="#1D8DBA" points="19.18 40.554 19.18 43.631 31.829 36.328 31.829 33.251" />
          <polygon
            fill="url(#appdynamics-node-insights-v)"
            points="19.18 40.554 19.18 43.631 31.829 36.328 31.829 33.251"
          />
          <polygon
            fill="#097496"
            points="19.18 38.794 6.531 31.491 6.531 28.416 19.18 24.188 31.829 28.416 31.829 31.491"
          />
          <polygon
            fill="url(#appdynamics-node-insights-w)"
            points="19.18 38.794 6.531 31.491 6.531 28.416 19.18 24.188 31.829 28.416 31.829 31.491"
          />
          <polygon
            fill="url(#appdynamics-node-insights-x)"
            points="19.18 35.716 6.531 28.416 19.18 21.113 31.829 28.416"
          />
          <polygon
            fill="url(#appdynamics-node-insights-y)"
            points="19.18 35.716 6.531 28.416 19.18 21.113 31.829 28.416"
          />
          <polygon fill="#1D8DBA" points="19.18 35.716 19.18 38.794 31.829 31.491 31.829 28.416" />
          <polygon
            fill="url(#appdynamics-node-insights-z)"
            points="19.18 35.716 19.18 38.794 31.829 31.491 31.829 28.416"
          />
          <image
            width="39.049"
            height="29.177"
            y=".197"
            opacity=".6"
            transform="translate(14.26 4.826)"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALIAAACFCAYAAAD/9aJ9AAAABGdBTUEAALGOfPtRkwAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAsqADAAQAAAABAAAAhQAAAABtoLBHAAAS8ElEQVR4Ae2dy3IbR7KGq6obxIUEqRvlsY4XJxyzGkecjV7A21mcpd5H7+OlX0AvoM2J8KwcE7NwaMa8gyCJW3fV+bIbgAhQBEEQEoBCdgSIbqBxqayPib8rs7JsCMHophbYdAu4TW+Afn+1gFhAQVYOorCAghxFN2ojFGRlIAoLKMhRdKM2QkFWBqKwgIIcRTdqIxRkZSAKCyjIUXSjNkJBVgaisICCHEU3aiMUZGUgCgsoyFF0ozZCQVYGorCAghxFN2ojFGRlIAoLKMhRdKM2QkFWBqKwgIIcRTdqIxRkZSAKCyjIUXSjNkJBVgaisICCHEU3aiMUZGUgCgsoyFF0ozZCQVYGorCAghxFN2ojFGRlIAoLKMhRdKM2QkH+BgxYtm/wMVv9EVbLyi6//2+BC8DvbkH8i9TwLer4Ynet57tE0yvIyzRm6XkB92dnfjp05vrYvem3nfn+jXF/noQ/0mowu4fe/HbsjfnAzQjPCvQS+kBBXoYRRwD/DMB/1JPvGnnac/1KI2mmWc8moZ5Z20kDHOcd0xnUTX3wqVvLFOglGH/4FgryE2w5lBClB/5rCXAlt9VuzVSTwU7Npb6WmKQSkswNcu9TW+n7POn6zHf66WUP0Pufuv8E6L/lxvzi1Tsv3hkK8oK2KyF+h4T4R/Km9mN6k7d30qRad8Y1Kj7ZC842Q/C71pkq+4n1AViTjnX+yvnQHmT5VfD+ZnCTdM+yTt+8bOfm4/9yznuVGwv0iYL8SKOVAL+35u2viTltJi/S+k6lkdesazTSJDTzkD2zLnlujX1mTdjn7evG2sQbn1lvr3m8Zaw/D96c81jLJoMra/Ob/nXeO+7VB+aHTm4+qH5+ZLcYBXlOi41lxFAHH1Y7lZ3dpBpC0gh5ZQ9PfGCde8GV2ysu4V45G9i3B7x9g8G3hEu6jPGKK2PNOY+d8n7HuN/TkGfnLg3tbs9d17NBZ5CE3p83SWZ+B2i9IJyzd4yC/JClxgAbLuRu6eBOWqnXqn4XP9u0Sfo8MeYlmuAwWPPaBXMIsEOQQ90Gw0M247NuCpA9AFtzZG045rETE/yZN6418KYdbO86y3sd1c8P9czk8+qRJ+0xcVRCfFcH21DdrTjTdMYfGOte8KJXIdhDPO9rvPEh8uElnvkZx3t44SruwnGfA3OH/Tb75zx3Erw95viYq8UTRuJOM+/OEmsusty2g79R/TzRG7MPFOQv2KcEeJYONs9S5wG4ABYpAcQObxyQFda+AMwDvPMe+zX2K4Dr8MRIhdDn426AvM19ywZ7FgC4gNnbE4/cEKi5CMRDq37+Qtfc+5CCfMs0Yxkxhw52IiNcKCEWoNHEvNUBIHKBZxvAWwNegTjhnoeDB+CcnT7gi2e+5rk2XrrF684EYG/DETIEyaH6+Va3zLWbznVW5CeNAR7p4LM8rVR9tZPu1Y3xuyEvdTCJKYUOBsvXwIqMsK8wDQAHAbjJ8S6A1vGyO7CbAi5KAW9cbPhfjjk3YSfleZEcDZ7aY3SD15p9IN7Hix9A/AEXiwcmSU4M3rlaca1eUi3087O9TqfxVsaffyrGn/nuOv6MEbfeI5cQL6KDRUaY53jUfUDcxZQ1wAXgUGEfYAVgtLE4488bp4As/x3cMnbkArDH7YazrjhuobHPVD9jkUduWwtyCfD7GePBc+hgvCn2Fq9aBUT5dZObeGChd3Rjd2IbwTwGmmdFO3dhXPTzJfuqnydM9vDB1oE8lhHL0MEGHYwX5jYPwNO9gQLB/1qDNGZEw4YM8lU/T1tpzuOtAXkM8EgHk9gjeRGzx4PtazxkoYORDAy13dbByIiADibYIePEPHefB57VFby9OGYrUoNbkCG6QQG0CV32iQSGS04556wT9PMxIyM6/vwFi24FyN9IBwvIi25C8+j2JP1sCKj026b3OX/jI8N+eH62Rb/cJrwuapDHXvjt23FexE6TAAUBjTIv4qvp4EX7fgSz3BdAc/9o/ewy3zb9fqefDPM3tiDcHeXw2xjgoYw47JIXUUuqqNm6t67pbF5E5JyVvAj7eTzYMrwmw2lWxoMl4cc2cLNP0cGPBXokT0Q/y3gdUWzC2zYwXFdImeGQHcEWyeMI9hnf9Tlnsm/2XeKanH7qTXaepLstCXc/q2zHcF10Hvk+GVHDC+cmP7ibF/HVdfBjYR6dz/+UOOZH6mcfjnjNCR0r+RwXhL0vtyHcHQ3IJcDvvzyc5rwEG54Fa18Cxyvyg19/zot41HjwU3TwCNDH3gvNo9vD+lkuBkM48oZwt1wcbkm4e+NBHsuIh4bTCCmTuUN2WgnxRF7EYuPBjwXyqeePYJb7L+vnYC5A/gy5cYw3PiLmd0Rq6dE2pIturEYeAzwaTpsVVvb+tcELM2hLWNkcQoLo4GHi+zfXwYsC/aB+RktL7rNk3O3xj7pvnNsn3L2/DeHujfTIJcSPCysz+vSakNtLAJbkd6TGKC9iKePBi8K56OtogjjmSf3MA0V2HcSTjLRd4e6NArkE+B4dXEwzmms4rUmHS1j5vryIVehgvs5Cm9A8un1ZbmxJuHsjQB7LiId0MFG4B9Mrv+1w2kJ0LvCi2+Fuj8Qoo4NblC661iCPAR7p4OWElStcCCEbFw4rL8DZN3kJnlmc86Tc4OcFuRF/uHttQV5EB5fTjNZ+OO1rUz2SGnL/8HDdjOlWmxTuXjuQx154c8LKXxvMRd//DtC8UbTh7rUCeeyF/3qVFtPtcwkr79R9Slj51nT7LdXBiwP9xHRRqiW1urdnd5tPA/NxvZKR1gLksRc2JPf8sJM+e1WtViqNWjVP90jWlfHQF5PT7dc2rLwobF/7dXhncdCP1M+3w93OnlOmoE32x3Xe73SKYjK/7zHDZT1Kfa0LyAzxAvHbN5X9br+2V9vZy63fd948T61jnpwk9khEjsCGzFiWHOH5pxlt0nDaNwB6crgOvO+fbjUKd1t3RP4/NTjI3xj4i35mLvNeuDmTaVprAvPKI3ulN/7ZmR8O0/3uZW13J2lal1PwpEK1HvPaW/MdKWB/kX0SwmS6PfkSTLcfhpV5rJhmBK20hUpr/ClvxLh0m7bA0Dale+ZJzDqeosVcQ5myxeRZaxpEBmUaVxOTEjzyTRLxdkNwtVBxlUrK/PFa3766qoaTn3iv33AvmHuVOc8rBxljWakl/KJ3VbFU7/Eu2Xcmf0nk7Xs8wH9hn+8x9l8wEtV7LDXVivTKXR77lumVfM2ots9AfzFdlMKL1taxNYEjwt7GAjezviko6ii+QV/4mq1mfi8M3phu/sn8zOjIB0ngX9m2UpCHF3dWCmJnu1XKAbpqmlPBkjxbrk9eATHT7sP3eN/vwF08cZEjjLcQLyzjwU+ZZrQyo6/RBxcTtACW2hviU+UXTfalbEHhqSvYXkoX4Lmh1zENKzddiote0z/XfW9vKALWM2/b1nwsfgk5fTWb/BSvfqMadqjtuLwfUmqgUdTEVflSUh+CnzNyIvhZk2NsWU65J9Gc6JVCvJyewyeIgy5mf8ODlDKwFR5hJo2VXz3xyvSD2UVENAC+nrtQzemnnYFN8r0bZ7rd4g2W83UWe5f1AFm++zVsJikTOMigRVvgAQYYlJvcF/vMMrYZETl+wijQKlfgnMQrR7fFLKCvGllgZEeRukVVJJwFF4J2gEOhD4yEvTM0BOVxqVrnPDdqzbTEaa9+W6m0KJv/C2r37z7pUmA1Cf1KzXSYkswwD7m1ngsOW2hh+amDWKoKU0wYg+Kto0j6WTUBY3j5IpNRwBCoHGqpsREYnHCn3J/ioc8Yw2cKlb32ue3leTdLqh1vavJDudptpSDLvz7KLJjfj/zF/7wc7CUJK21ULvmZqEBu6pithkcQcKnGYzt4iBuuNJjpYZplGmYhP4bT8qkKX+ZPiEV5iW4zLAB4wt7dcWV+5Lp0yhX3ZRkCG0749fuTs//D4/+mDyhH4M6t71/3ne212gzf/fYj/wQfVwrzSkEeGhoDfPTm5u/ZVVLpUnDKNXa4lEZi4Jn7/Mp1wP2KnzIMay95RqYrvcCgRcFAjIxuM1L1cod7aY/IJQF5dBt+jN4NLcAPG1cbDMqLTBP5gKH67I8LK3JeCzsXhRW5Zw5gOEIj/4nTPrHF1Kns4qpTvWrvXPfNv1gywnwQn7RSkNclICLQsR7HOxzx8U6z1qzt+Xw3cWYfS1PCVWoQzyjhuhlTlVb9nySgjW6FjOB47twLXsnsbN/qZaGd+XDT2nE985FQtVmPUPVagCw9XA7F4UUlWci8qTwbLi7zcFFtjfKJ/WZsI3jlflIHP7J44kQ23L8kIvhB3m/l3ljavjYgF19GhjILSUCkb+5lDh7Mu4g1/1hMNmsDXGH3rg7m8ejKca0VyKNeGXtnnREyMslj74c6uCiQuBUzRtbhYu9OJw0vHMoRDfPeH7/91ZujZvYi3RlUGoNecI1OSsV3BjvbjGxICVYp8nfO5Yas41EsgcCLyyUQJF8gnjl6d2w19YC44PImVT4lIchyIWdsWbLWMhIhc/i4kOO0YskHzmL9EtYykYr5uWcpiHLJB4rr3zjS3f4YLZn2f+sjI6baXByupUee/qKlh97qWdPTJpk+Bl7hd1JG8MDWzKreCJCl18ZyY575e9SxKNI+g6yyVC4VhmeijsVwfY+4Eo5uy4jxcBpDlTLuTllaCodTtIWrMlnbT4bRoixLuzEgC8yyjYF+SD9vfmWhssH3//0sI4ajEZw6OZy2RZWH1lIj3993/ICWA++z9bPxN6zQeBWswxuFFllbLbSzrM8hGlGy6uZd+0NGUdZtuwMwD0wlx7NS1GgtElPWgiMCwpp+7niTdfCsjtg4jzzdmPv08wZW35xu2vQxvArDkzqY/zS88IzhtNvTlSKuzrnxIEtvj+XGUD9HOHH1Xh1MJGCu9fruTCDt/rNY3mxd5txN/9c+9jgKkEeNHgMdTymBOzKCtk7q4DlKYm1DBfuN08gjaL90P6mf3/mzn/7h37gfs5v8YpCaas+aaocx1CvWkG6hFy/wZhdECy7WUD/fAZgH7tfBwaB/zTHj6SyYE07JFC7WtM59Qjpsdt1hFsdZlvfNSxJ8fiumJImp5DOi2aLyyLd7Zeyd5xmuk+V4mVZF1uhDqzh97XA3cAlfj9TBLMzOi05I12aYzbUGnmqct+tQRCYjbvfzaD9akMcNhGj2rXlouG71BRCfrINdGtrdnruuZ4POIAm9P2+SzGzBQjjS11FJixG8t+8n5cZahrvFBZe3LQsr3+6np+5H75GnDVRKjrUId38G+Inplduw2M10P04fbx3IYoBH6eflh7sBWBhWHTwN41OOtxLkkcHGQD+kn58W7paPE50u9Mpfgmzbk15ZtPkb/IleI8+y4Vz6+cnh7gJi+RqllFAdPKtLFn5uqz3ytNXu089PCXeD8WgyLAloUi9CanXIrHDDmPb2LVozbfNlHSvIU5Ycy40nh7upyhNsFTcsy+8iLqjJURacmZhmFHt65ZR5v9qhgnyPacdALxbufs70+n3g3QVkqbvBIRWSbOgiMK4AuoV3ZpaGOUEvb9XCjveY+8kPb7VGnmW9Sf38iHB3IF2Uxdq5phvCTBVLitkBb4aHvqHwSYtp9dSMYIndEI5jT6+cZeNlPqceeQ5rjr3znOFu3vIVt5dICrwy1ZBIjAZgaqiZazzwBc+d2twzV86c5MGdJhGnV9LGb7IpyI8w8xjomcN15jmDay+4xHsOtE0qSdQZuC5A5qOop0YVH2/OqTV8xnSs84FUT9qyvIhHmHzuUxXkuU31+cQS6PcUk/k1MafN5AWVnSuNvMYC5o00cU3vKk2Xy9ongVKslMh1wTFcQfZa6Ng8XOWpvWRZibYdZFem3+/0k7xXrsnRkfJTXP8x1sz2+RN17yELKMgPWWjG8yXQk+HuyqBRc0lSt4mrO+drjjrC1K+z1BT2SW56IXFc8IWO91mn35b0yk6ZXrlmqyTNaPZaPqUgP7FbxnJD9DNLSHyXtCo916jUbK9SdfU0S00SsgG13jPfr9psx1YHnbPuoHF4Mfjj8pL84L/hhddjZaQnmmKlL1eQl2T+aaD/m+UkOvs7ic8PqHfZsza9DJVa0386bfsiwf2jlGL9ReSDyogl9IGCvAQj3n6Lz0DLo+/Igz4u4iHmgxwfAm4JrxypDhYrLGdTkJdjxy++yxDq8XMK7tgUS99RkJduUn3DVVhAElp0UwtsvAUU5I3vQm2AWEBBVg6isICCHEU3aiMUZGUgCgsoyFF0ozZCQVYGorCAghxFN2ojFGRlIAoLKMhRdKM2QkFWBqKwgIIcRTdqIxRkZSAKCyjIUXSjNkJBVgaisICCHEU3aiMUZGUgCgsoyFF0ozZCQVYGorCAghxFN2ojFGRlIAoLKMhRdKM2QkFWBqKwgIIcRTdqIxRkZSAKCyjIUXSjNkJBVgaisICCHEU3aiMUZGUgCgv8PyQEEbJtCDx5AAAAAElFTkSuQmCC"
          />
          <polygon
            fill="#097496"
            points="33.863 25.54 21.214 18.237 21.214 15.161 33.863 10.934 46.512 15.161 46.512 18.237"
          />
          <polygon
            fill="url(#appdynamics-node-insights-A)"
            points="33.863 25.54 21.214 18.237 21.214 15.161 33.863 10.934 46.512 15.161 46.512 18.237"
          />
          <polygon
            fill="url(#appdynamics-node-insights-B)"
            points="33.863 22.464 21.214 15.161 33.863 7.858 46.512 15.161"
          />
          <image
            width="39.049"
            height="29.396"
            y=".197"
            opacity=".6"
            transform="translate(14.26)"
            xlinkHref="data:image/png;base64,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"
          />
          <polygon fill="#1D8DBA" points="33.863 22.464 33.863 25.54 46.512 18.237 46.512 15.161" />
          <polygon
            fill="url(#appdynamics-node-insights-C)"
            points="33.863 22.464 33.863 25.54 46.512 18.237 46.512 15.161"
          />
          <polygon
            fill="#097496"
            points="33.863 20.705 21.214 13.402 21.214 10.324 33.863 6.099 46.512 10.324 46.512 13.402"
          />
          <polygon
            fill="url(#appdynamics-node-insights-D)"
            points="33.863 20.705 21.214 13.402 21.214 10.324 33.863 6.099 46.512 10.324 46.512 13.402"
          />
          <polygon
            fill="url(#appdynamics-node-insights-E)"
            points="33.863 17.627 21.214 10.324 33.863 3.021 46.512 10.324"
          />
          <polygon
            fill="url(#appdynamics-node-insights-F)"
            points="33.863 17.627 21.214 10.324 33.863 3.021 46.512 10.324"
          />
          <polygon
            fill="#1D8DBA"
            points="33.863 17.627 33.863 20.705 46.512 13.402 46.512 10.324"
          />
          <polygon
            fill="url(#appdynamics-node-insights-G)"
            points="33.863 17.627 33.863 20.705 46.512 13.402 46.512 10.324"
          />
          <g transform="translate(19.963 11.408)">
            <path
              fill="#94F5A9"
              d="M33.9460875,5.12240625 L33.9460875,6.5242125 C33.9439345,6.58978502 33.9125462,6.65095205 33.8605313,6.6909375 L29.5585875,9.1742625 C29.510325,9.2005875 29.4730303,9.1742625 29.4730303,9.10845 L29.4730303,7.7088375 C29.4728298,7.64267762 29.5047225,7.58052778 29.5585875,7.5421125 L33.8605313,5.0587875 C33.9087938,5.03026875 33.9460875,5.06098125 33.9460875,5.12240625 Z"
            />
            <path
              fill="url(#appdynamics-node-insights-H)"
              d="M33.9460875,5.12240625 L33.9460875,6.5242125 C33.9439345,6.58978502 33.9125462,6.65095205 33.8605313,6.6909375 L29.5585875,9.1742625 C29.510325,9.2005875 29.4730303,9.1742625 29.4730303,9.10845 L29.4730303,7.7088375 C29.4728298,7.64267762 29.5047225,7.58052778 29.5585875,7.5421125 L33.8605313,5.0587875 C33.9087938,5.03026875 33.9460875,5.06098125 33.9460875,5.12240625 Z"
            />
            <path
              fill="#097496"
              d="M33.9460875,5.12240625 L33.9460875,6.5242125 C33.9439345,6.58978502 33.9125462,6.65095205 33.8605313,6.6909375 L29.5585875,9.1742625 C29.510325,9.2005875 29.4730313,9.1742625 29.4730313,9.10845 L29.4730313,8.836425 L33.5073375,6.5066625 C33.5601782,6.46711702 33.5924067,6.40588295 33.5950875,6.3399375 L33.5950875,5.21235 L33.8605313,5.0587875 C33.9087938,5.03026875 33.9460875,5.06098125 33.9460875,5.12240625 Z"
            />
            <path
              fill="#94F5A9"
              d="M40.4286187,1.8252 L34.7687437,5.0938875 C34.7204812,5.12240625 34.6809937,5.0938875 34.6809937,5.028075 L34.6809937,4.6990125 C34.6836746,4.63306705 34.715903,4.57183298 34.7687437,4.5322875 L40.4286187,1.26579375 C40.4768813,1.237275 40.5163687,1.26579375 40.5163687,1.33160625 L40.5163687,1.658475 C40.5160677,1.72503702 40.4833151,1.7872671 40.4286187,1.8252 L40.4286187,1.8252 Z"
            />
            <path
              fill="#00EDB5"
              d="M40.4286187,2.89794375 L34.7687437,6.16663125 C34.7204812,6.19515 34.6809937,6.16663125 34.6809937,6.10081875 L34.6809937,5.77395 C34.6830195,5.70722545 34.7153165,5.64505368 34.7687437,5.60503125 L40.4286187,2.3385375 C40.4768813,2.31001875 40.5163687,2.3385375 40.5163687,2.40435 L40.5163687,2.73121875 C40.5160677,2.79778077 40.4833151,2.86001085 40.4286187,2.89794375 L40.4286187,2.89794375 Z"
            />
            <path d="M33.9460875,5.12240625 L33.9460875,6.5242125 C33.9439345,6.58978502 33.9125462,6.65095205 33.8605313,6.6909375 L29.5585875,9.1742625 C29.510325,9.2005875 29.4730303,9.1742625 29.4730303,9.10845 L29.4730303,7.7088375 C29.4728298,7.64267762 29.5047225,7.58052778 29.5585875,7.5421125 L33.8605313,5.0587875 C33.9087938,5.03026875 33.9460875,5.06098125 33.9460875,5.12240625 Z" />
            <path d="M33.9460875 5.12240625L33.9460875 6.5242125C33.9439345 6.58978502 33.9125462 6.65095205 33.8605313 6.6909375L29.5585875 9.1742625C29.510325 9.2005875 29.4730313 9.1742625 29.4730313 9.10845L29.4730313 8.836425 33.5073375 6.5066625C33.5601782 6.46711702 33.5924067 6.40588295 33.5950875 6.3399375L33.5950875 5.21235 33.8605313 5.0587875C33.9087938 5.03026875 33.9460875 5.06098125 33.9460875 5.12240625zM40.4286187 1.8252L34.7687437 5.0938875C34.7204812 5.12240625 34.6809937 5.0938875 34.6809937 5.028075L34.6809937 4.6990125C34.6836746 4.63306705 34.715903 4.57183298 34.7687437 4.5322875L40.4286187 1.26579375C40.4768813 1.237275 40.5163687 1.26579375 40.5163687 1.33160625L40.5163687 1.658475C40.5160677 1.72503702 40.4833151 1.7872671 40.4286187 1.8252L40.4286187 1.8252zM40.4286187 2.89794375L34.7687437 6.16663125C34.7204812 6.19515 34.6809937 6.16663125 34.6809937 6.10081875L34.6809937 5.77395C34.6830195 5.70722545 34.7153165 5.64505368 34.7687437 5.60503125L40.4286187 2.3385375C40.4768813 2.31001875 40.5163687 2.3385375 40.5163687 2.40435L40.5163687 2.73121875C40.5160677 2.79778077 40.4833151 2.86001085 40.4286187 2.89794375L40.4286187 2.89794375z" />
            <path
              fill="#94F5A9"
              d="M33.9460875,9.959625 L33.9460875,11.3614313 C33.9439345,11.4270038 33.9125462,11.4881708 33.8605313,11.5281563 L29.5585875,14.0114813 C29.510325,14.0378063 29.4730313,14.0114813 29.4730313,13.943475 L29.4730313,12.5438625 C29.473193,12.4777903 29.5050055,12.4157967 29.5585875,12.3771375 L33.8605313,9.8938125 C33.9087938,9.871875 33.9460875,9.89600625 33.9460875,9.959625 Z"
            />
            <path
              fill="url(#appdynamics-node-insights-I)"
              d="M33.9460875,9.959625 L33.9460875,11.3614313 C33.9439345,11.4270038 33.9125462,11.4881708 33.8605313,11.5281563 L29.5585875,14.0114813 C29.510325,14.0378063 29.4730313,14.0114813 29.4730313,13.943475 L29.4730313,12.5438625 C29.473193,12.4777903 29.5050055,12.4157967 29.5585875,12.3771375 L33.8605313,9.8938125 C33.9087938,9.871875 33.9460875,9.89600625 33.9460875,9.959625 Z"
            />
            <path
              fill="#097496"
              d="M33.9460875,9.959625 L33.9460875,11.3614313 C33.9439345,11.4270038 33.9125462,11.4881708 33.8605313,11.5281563 L29.5585875,14.0114813 C29.510325,14.0378063 29.4730313,14.0114813 29.4730313,13.943475 L29.4730313,13.6736438 L33.5073375,11.3438813 C33.5601782,11.3043358 33.5924067,11.2431017 33.5950875,11.1771563 L33.5950875,10.047375 L33.8605313,9.8938125 C33.9087938,9.871875 33.9460875,9.89600625 33.9460875,9.959625 Z"
            />
            <path
              fill="#94F5A9"
              d="M40.4286187,6.66241875 L34.7687437,9.93110625 C34.7204812,9.95743125 34.6809937,9.93110625 34.6809937,9.8631 L34.6809937,9.53623125 C34.6836746,9.4702858 34.715903,9.40905173 34.7687437,9.36950625 L40.4286187,6.1030125 C40.4768813,6.07449375 40.5163687,6.1030125 40.5163687,6.168825 L40.5163687,6.49569375 C40.5136879,6.5616392 40.4814595,6.62287327 40.4286187,6.66241875 Z"
            />
            <path
              fill="#00EDB5"
              d="M40.4286187,7.7351625 L34.7687437,11.00385 C34.7204812,11.030175 34.6809937,11.00385 34.6809937,10.9380375 L34.6809937,10.608975 C34.6836746,10.5430295 34.715903,10.4817955 34.7687437,10.44225 L40.4286187,7.17575625 C40.4768813,7.1472375 40.5163687,7.17575625 40.5163687,7.24156875 L40.5163687,7.5684375 C40.5136879,7.63438295 40.4814595,7.69561702 40.4286187,7.7351625 Z"
            />
            <path
              fill="#94F5A9"
              d="M19.2150563,13.6582875 L19.2150563,15.0579 C19.2129033,15.1234725 19.1815149,15.1846395 19.1295,15.224625 L14.8275563,17.70795 C14.7792938,17.7364688 14.7419991,17.70795 14.7419991,17.6421375 L14.7419991,16.23375 C14.7417986,16.1675901 14.7736913,16.1054403 14.8275563,16.067025 L19.1295,13.60125 C19.1777625,13.5639563 19.2150563,13.60125 19.2150563,13.6582875 Z"
            />
            <path
              fill="url(#appdynamics-node-insights-J)"
              d="M19.2150563,13.6582875 L19.2150563,15.0579 C19.2129033,15.1234725 19.1815149,15.1846395 19.1295,15.224625 L14.8275563,17.70795 C14.7792938,17.7364688 14.7419991,17.70795 14.7419991,17.6421375 L14.7419991,16.23375 C14.7417986,16.1675901 14.7736913,16.1054403 14.8275563,16.067025 L19.1295,13.60125 C19.1777625,13.5639563 19.2150563,13.60125 19.2150563,13.6582875 Z"
            />
            <path
              fill="#097496"
              d="M19.2150562,13.6582875 L19.2150562,15.0579 C19.2129033,15.1234725 19.1815149,15.1846395 19.1295,15.224625 L14.8275562,17.70795 C14.7792937,17.7364687 14.742,17.70795 14.742,17.6421375 L14.742,17.3701125 L18.7763062,15.04035 C18.829147,15.0008045 18.8613754,14.9395705 18.8640562,14.873625 L18.8640562,13.7460375 L19.1295,13.592475 C19.1777625,13.5639563 19.2150562,13.60125 19.2150562,13.6582875 Z"
            />
            <path
              fill="#94F5A9"
              d="M25.6975875,10.3588875 L20.0377125,13.627575 C19.98945,13.6560938 19.9499625,13.627575 19.9499625,13.5617625 L19.9499625,13.2348938 C19.9519882,13.1681692 19.9842852,13.1059974 20.0377125,13.065975 L25.6975875,9.79948125 C25.74585,9.7709625 25.7853375,9.79948125 25.7853375,9.86529375 L25.7853375,10.1921625 C25.7850365,10.2587245 25.7522838,10.3209546 25.6975875,10.3588875 Z"
            />
            <path
              fill="#00EDB5"
              d="M25.6975875,11.433825 L20.0377125,14.698125 C19.98945,14.7266438 19.9499625,14.698125 19.9499625,14.6323125 L19.9499625,14.3054438 C19.9502635,14.2388817 19.9830162,14.1766516 20.0377125,14.1387188 L25.6975875,10.8700313 C25.74585,10.8415125 25.7853375,10.8700313 25.7853375,10.9358438 L25.7853375,11.2627125 C25.7839769,11.3302142 25.7516101,11.3933295 25.6975875,11.433825 Z"
            />
            <path
              fill="#94F5A9"
              d="M19.2150562,8.81229375 L19.2150562,10.2141 C19.2129033,10.2796725 19.1815149,10.3408395 19.1295,10.380825 L14.8275562,12.86415 C14.7792937,12.890475 14.742,12.86415 14.742,12.7961437 L14.742,11.4075 C14.7421617,11.3414278 14.7739743,11.2794342 14.8275562,11.240775 L19.1295,8.75745 C19.1777625,8.7179625 19.2150562,8.748675 19.2150562,8.81229375 Z"
            />
            <path
              fill="url(#appdynamics-node-insights-K)"
              d="M19.2150562,8.81229375 L19.2150562,10.2141 C19.2129033,10.2796725 19.1815149,10.3408395 19.1295,10.380825 L14.8275562,12.86415 C14.7792937,12.890475 14.742,12.86415 14.742,12.7961437 L14.742,11.4075 C14.7421617,11.3414278 14.7739743,11.2794342 14.8275562,11.240775 L19.1295,8.75745 C19.1777625,8.7179625 19.2150562,8.748675 19.2150562,8.81229375 Z"
            />
            <path
              fill="#097496"
              d="M19.2150562,8.81229375 L19.2150562,10.2141 C19.2129033,10.2796725 19.1815149,10.3408395 19.1295,10.380825 L14.8275562,12.86415 C14.7792937,12.890475 14.742,12.86415 14.742,12.7961438 L14.742,12.5263125 L18.7763062,10.19655 C18.829147,10.1570045 18.8613754,10.0957705 18.8640562,10.029825 L18.8640562,8.90004375 L19.1295,8.74648125 C19.1777625,8.7179625 19.2150562,8.748675 19.2150562,8.81229375 Z"
            />
            <path
              fill="#94F5A9"
              d="M25.6975875,5.5150875 L20.0377125,8.775 C19.98945,8.80351875 19.9499625,8.775 19.9499625,8.7091875 L19.9499625,8.38231875 C19.9526433,8.3163733 19.9848718,8.25513923 20.0377125,8.21559375 L25.6975875,4.9491 C25.74585,4.92058125 25.7853375,4.9491 25.7853375,5.0149125 L25.7853375,5.34178125 C25.7846521,5.41005808 25.7522143,5.47412278 25.6975875,5.5150875 Z"
            />
            <path
              fill="#00EDB5"
              d="M25.6975875,6.58125 L20.0377125,9.8499375 C19.98945,9.8762625 19.9499625,9.8499375 19.9499625,9.78193125 L19.9499625,9.4550625 C19.9526433,9.38911705 19.9848718,9.32788298 20.0377125,9.2883375 L25.6975875,6.02184375 C25.74585,5.993325 25.7853375,6.02184375 25.7853375,6.08765625 L25.7853375,6.414525 C25.7826567,6.48047045 25.7504282,6.54170452 25.6975875,6.58125 Z"
            />
            <path
              fill="#94F5A9"
              d="M19.2150563,3.96849375 L19.2150563,5.36810625 C19.2135565,5.43445521 19.1821015,5.49655875 19.1295,5.537025 L14.8275563,8.01815625 C14.7792938,8.046675 14.7419991,8.01815625 14.7419991,7.95234375 L14.7419991,6.55273125 C14.7417986,6.48657137 14.7736913,6.42442153 14.8275563,6.38600625 L19.1295,3.90268125 C19.1777625,3.8741625 19.2150563,3.904875 19.2150563,3.96849375 Z"
            />
            <path
              fill="url(#appdynamics-node-insights-L)"
              d="M19.2150563,3.96849375 L19.2150563,5.36810625 C19.2135565,5.43445521 19.1821015,5.49655875 19.1295,5.537025 L14.8275563,8.01815625 C14.7792938,8.046675 14.7419991,8.01815625 14.7419991,7.95234375 L14.7419991,6.55273125 C14.7417986,6.48657137 14.7736913,6.42442153 14.8275563,6.38600625 L19.1295,3.90268125 C19.1777625,3.8741625 19.2150563,3.904875 19.2150563,3.96849375 Z"
            />
            <path
              fill="#097496"
              d="M19.2150562,3.96849375 L19.2150562,5.36810625 C19.2135565,5.43445521 19.1821015,5.49655875 19.1295,5.537025 L14.8275562,8.01815625 C14.7792937,8.046675 14.742,8.01815625 14.742,7.95234375 L14.742,7.678125 L18.7763062,5.3483625 C18.829147,5.30881702 18.8613754,5.24758295 18.8640562,5.1816375 L18.8640562,4.05405 L19.1295,3.9004875 C19.1777625,3.8741625 19.2150562,3.904875 19.2150562,3.96849375 Z"
            />
            <path
              fill="#94F5A9"
              d="M25.6975875,0.6712875 L20.0377125,3.94875 C19.98945,3.97726875 19.9499625,3.94875 19.9499625,3.8829375 L19.9499625,3.55606875 C19.9502635,3.48950673 19.9830162,3.42727665 20.0377125,3.38934375 L25.6975875,0.12065625 C25.74585,0.0921375 25.7853375,0.12065625 25.7853375,0.18646875 L25.7853375,0.5133375 C25.7801348,0.576148198 25.7481688,0.633687123 25.6975875,0.6712875 Z"
            />
            <path
              fill="#00EDB5"
              d="M25.6975875,1.755 L20.0377125,5.02149375 C19.98945,5.0500125 19.9499625,5.02149375 19.9499625,4.95568125 L19.9499625,4.6288125 C19.9502635,4.56225048 19.9830162,4.5000204 20.0377125,4.4620875 L25.6975875,1.1934 C25.74585,1.16488125 25.7853375,1.1934 25.7853375,1.2592125 L25.7853375,1.588275 C25.7826567,1.65422045 25.7504282,1.71545452 25.6975875,1.755 Z"
            />
            <path
              fill="#94F5A9"
              d="M19.2150562,18.4933125 L19.2150562,19.8951187 C19.2129033,19.9606913 19.1815149,20.0218583 19.1295,20.0618437 L14.8275562,22.5451687 C14.7792937,22.5714937 14.742,22.5451687 14.742,22.4771625 L14.742,21.0797437 C14.7434997,21.0133948 14.7749548,20.9512913 14.8275562,20.910825 L19.1295,18.4275 C19.1777625,18.3989812 19.2150562,18.4275 19.2150562,18.4933125 Z"
            />
            <path
              fill="url(#appdynamics-node-insights-M)"
              d="M19.2150562,18.4933125 L19.2150562,19.8951187 C19.2129033,19.9606913 19.1815149,20.0218583 19.1295,20.0618437 L14.8275562,22.5451687 C14.7792937,22.5714937 14.742,22.5451687 14.742,22.4771625 L14.742,21.0797437 C14.7434997,21.0133948 14.7749548,20.9512913 14.8275562,20.910825 L19.1295,18.4275 C19.1777625,18.3989812 19.2150562,18.4275 19.2150562,18.4933125 Z"
            />
            <line
              x1="14.828"
              x2="19.13"
              y1="20.911"
              y2="18.43"
              fill="url(#appdynamics-node-insights-N)"
            />
            <path
              fill="#097496"
              d="M19.2150562,18.4933125 L19.2150562,19.8951188 C19.2129033,19.9606913 19.1815149,20.0218583 19.1295,20.0618438 L14.8275562,22.5451688 C14.7792937,22.5714938 14.742,22.5451688 14.742,22.4771625 L14.742,22.2073313 L18.7763062,19.8775688 C18.829147,19.8380233 18.8613754,19.7767892 18.8640562,19.7108438 L18.8640562,18.5832563 L19.1295,18.4296938 C19.1777625,18.3989813 19.2150562,18.4275 19.2150562,18.4933125 Z"
            />
            <path
              fill="#94F5A9"
              d="M25.6975875,15.1961062 L20.0377125,18.4647937 C19.98945,18.4911187 19.9499625,18.4647937 19.9499625,18.3989812 L19.9499625,18.0699187 C19.9526433,18.0039733 19.9848718,17.9427392 20.0377125,17.9031937 L25.6975875,14.6367 C25.74585,14.6081812 25.7853375,14.6367 25.7853375,14.7025125 L25.7853375,15.0293813 C25.7826567,15.0953267 25.7504282,15.1565608 25.6975875,15.1961062 Z"
            />
            <path
              fill="#00EDB5"
              d="M25.6975875,16.26885 L20.0377125,19.5375375 C19.98945,19.5638625 19.9499625,19.5375375 19.9499625,19.471725 L19.9499625,19.1426625 C19.9526433,19.076717 19.9848718,19.015483 20.0377125,18.9759375 L25.6975875,15.7094437 C25.74585,15.680925 25.7853375,15.7094437 25.7853375,15.7752562 L25.7853375,16.102125 C25.7850365,16.168687 25.7522838,16.2309171 25.6975875,16.26885 Z"
            />
            <path
              fill="#94F5A9"
              d="M4.54545,22.0779 L4.54545,23.473125 C4.54395027,23.539474 4.51249523,23.6015775 4.45989375,23.6420437 L0.15795,26.1275625 C0.1096875,26.1560812 0.0723928017,26.1275625 0.0723928017,26.06175 L0.0723928017,24.6621375 C0.0721923414,24.5959776 0.104085023,24.5338278 0.15795,24.4954125 L4.45989375,22.0120875 C4.50815625,21.9835687 4.54545,22.0142812 4.54545,22.0779 Z"
            />
            <path
              fill="url(#appdynamics-node-insights-L)"
              d="M4.54545,22.0779 L4.54545,23.473125 C4.54395027,23.539474 4.51249523,23.6015775 4.45989375,23.6420437 L0.15795,26.1275625 C0.1096875,26.1560812 0.0723928017,26.1275625 0.0723928017,26.06175 L0.0723928017,24.6621375 C0.0721923414,24.5959776 0.104085023,24.5338278 0.15795,24.4954125 L4.45989375,22.0120875 C4.50815625,21.9835687 4.54545,22.0142812 4.54545,22.0779 Z"
            />
            <path
              fill="#097496"
              d="M4.54545,22.0779 L4.54545,23.473125 C4.54395027,23.539474 4.51249523,23.6015775 4.45989375,23.6420437 L0.15795,26.1275625 C0.1096875,26.1560812 0.07239375,26.1275625 0.07239375,26.06175 L0.07239375,25.789725 L4.1067,23.4599625 C4.15954074,23.420417 4.1917692,23.359183 4.19445,23.2932375 L4.19445,22.156875 L4.45989375,22.0033125 C4.50815625,21.9835687 4.54545,22.0142812 4.54545,22.0779 Z"
            />
            <path
              fill="#94F5A9"
              d="M11.0279813,18.7806938 L5.36810625,22.0471875 C5.31984375,22.0757063 5.28035625,22.0471875 5.28035625,21.981375 L5.28035625,21.6545063 C5.28065725,21.5879442 5.31340993,21.5257141 5.36810625,21.4877813 L11.0279813,18.2190938 C11.0762438,18.190575 11.1157313,18.2190938 11.1157313,18.2849063 L11.1157313,18.6139688 C11.1130504,18.6799142 11.080822,18.7411483 11.0279813,18.7806938 L11.0279813,18.7806938 Z"
            />
            <path
              fill="#00EDB5"
              d="M11.0279813,19.8534375 L5.36810625,23.1199313 C5.31984375,23.14845 5.28035625,23.1199313 5.28035625,23.0541188 L5.28035625,22.72725 C5.28065725,22.660688 5.31340993,22.5984579 5.36810625,22.560525 L11.0279813,19.2918375 C11.0762438,19.2655125 11.1157313,19.2918375 11.1157313,19.35765 L11.1157313,19.6867125 C11.1130504,19.752658 11.080822,19.813892 11.0279813,19.8534375 Z"
            />
            <path
              fill="#94F5A9"
              d="M4.54545,26.912925 L4.54545,28.3147313 C4.54329703,28.3803038 4.51190869,28.4414708 4.45989375,28.4814563 L0.15795,30.9647813 C0.1096875,30.9911063 0.07239375,30.9647813 0.07239375,30.896775 L0.07239375,29.4993563 C0.0738934822,29.4330073 0.105348521,29.3709038 0.15795,29.3304375 L4.45989375,26.8493063 C4.50815625,26.8207875 4.54545,26.8515 4.54545,26.912925 Z"
            />
            <path
              fill="url(#appdynamics-node-insights-O)"
              d="M4.54545,26.912925 L4.54545,28.3147313 C4.54329703,28.3803038 4.51190869,28.4414708 4.45989375,28.4814563 L0.15795,30.9647813 C0.1096875,30.9911063 0.07239375,30.9647813 0.07239375,30.896775 L0.07239375,29.4993563 C0.0738934822,29.4330073 0.105348521,29.3709038 0.15795,29.3304375 L4.45989375,26.8493063 C4.50815625,26.8207875 4.54545,26.8515 4.54545,26.912925 Z"
            />
            <path
              fill="#097496"
              d="M4.54545,26.912925 L4.54545,28.3147312 C4.54329703,28.3803038 4.51190869,28.4414708 4.45989375,28.4814562 L0.15795,30.9647812 C0.1096875,30.9911062 0.07239375,30.9647812 0.07239375,30.896775 L0.07239375,30.6269437 L4.1067,28.299375 C4.15954074,28.2598295 4.1917692,28.1985955 4.19445,28.13265 L4.19445,27.0050625 L4.45989375,26.8515 C4.50815625,26.8207875 4.54545,26.8515 4.54545,26.912925 Z"
            />
            <path
              fill="#94F5A9"
              d="M11.0279813,23.6157188 L5.36810625,26.8844063 C5.31984375,26.9107313 5.28035625,26.8844063 5.28035625,26.8185938 L5.28035625,26.4895313 C5.28303705,26.4235858 5.31526551,26.3623517 5.36810625,26.3228063 L11.0279813,23.0563125 C11.0762438,23.0277938 11.1157313,23.0563125 11.1157313,23.122125 L11.1157313,23.4489938 C11.1154302,23.5155558 11.0826776,23.5777859 11.0279813,23.6157188 L11.0279813,23.6157188 Z"
            />
            <path
              fill="#00EDB5"
              d="M11.0279813,24.6884625 L5.36810625,27.95715 C5.31984375,27.9856687 5.28035625,27.95715 5.28035625,27.8913375 L5.28035625,27.562275 C5.28303705,27.4963295 5.31526551,27.4350955 5.36810625,27.39555 L11.0279813,24.13125 C11.0762438,24.1027312 11.1157313,24.13125 11.1157313,24.1970625 L11.1157313,24.5239312 C11.1147214,24.5897157 11.0820493,24.6509758 11.0279813,24.6884625 L11.0279813,24.6884625 Z"
            />
          </g>
        </g>
        <g transform="translate(433 226)">
          <circle
            cx="48"
            cy="48"
            r="48"
            fill="#04EAAE"
            filter="url(#appdynamics-node-insights-P)"
            opacity=".567"
          />
          <circle cx="48" cy="48" r="48" fill="#04EAAE" />
          <circle
            cx="48"
            cy="48"
            r="36"
            fill="url(#appdynamics-node-insights-d)"
            stroke="#FFF"
            strokeWidth="3"
          />
        </g>
        <g transform="translate(273)">
          <g transform="translate(6)">
            <circle cx="24" cy="24" r="24" fill="#04EAAE" />
            <circle
              cx="24"
              cy="24"
              r="18"
              fill="url(#appdynamics-node-insights-d)"
              stroke="#FFF"
              strokeWidth="1.5"
            />
          </g>
          <g transform="translate(0 8)">
            <image width="59.473" height="32.766" x=".047" y="1.884" xlinkHref={MiniCloud} />
            <polygon
              fill="url(#appdynamics-node-insights-Q)"
              points="30.99 24.293 42.279 25.511 48.074 22.615 48.074 16.721 48.885 23.249 42.279 26.596"
            />
            <polygon
              fill="url(#appdynamics-node-insights-R)"
              points="26.214 3.586 29.053 .112 35.304 1.033 38.669 7.991 34.616 1.519 29.83 .704 29.83 1.845"
            />
          </g>
        </g>
        <g transform="translate(55 76)">
          <use
            fill="#000"
            filter="url(#appdynamics-node-insights-S)"
            xlinkHref="#appdynamics-node-insights-T"
          />
          <use fill="#F7FBFB" xlinkHref="#appdynamics-node-insights-T" />
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="234" y="89">
              Business Transaction Health
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="8">
            <tspan x="122" y="7">
              Response Time
            </tspan>
          </text>
          <text fill="#1B92B9" fontFamily="ArialMT, Arial" fontSize="8">
            <tspan x="286.422" y="7">
              238 ms avg.
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="10" opacity=".5">
            <tspan x="234" y="123">
              2 critical, 0 warning, 36 normal
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="234" y="153">
              Node Health
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="234" y="217">
              Server Health
            </tspan>
          </text>
          <line
            x1="237"
            x2="419.999"
            y1="105"
            y2="104.501"
            stroke="#00D180"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-U)"
            opacity=".4"
          />
          <line
            x1="237"
            x2="247"
            y1="105"
            y2="105"
            stroke="#F60404"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-V)"
            opacity=".4"
          />
          <line
            x1="237"
            x2="419.999"
            y1="169"
            y2="168.501"
            stroke="#00D180"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-W)"
            opacity=".4"
          />
          <line
            x1="237"
            x2="269"
            y1="169"
            y2="169"
            stroke="#FFD302"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-X)"
            opacity=".4"
          />
          <line
            x1="237"
            x2="419.999"
            y1="105"
            y2="104.501"
            stroke="#00D180"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <line
            x1="237"
            x2="247"
            y1="105"
            y2="105"
            stroke="#F60404"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="10" opacity=".5">
            <tspan x="234" y="187">
              0 critical, 4 warning, 18 normal
            </tspan>
          </text>
          <line
            x1="237"
            x2="419.999"
            y1="169"
            y2="168.501"
            stroke="#00D180"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="10" opacity=".5">
            <tspan x="234" y="251">
              0 critical, 0 warning, 112 normal
            </tspan>
          </text>
          <line
            x1="237"
            x2="419.999"
            y1="233"
            y2="232.501"
            stroke="#00D180"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-Y)"
            opacity=".4"
          />
          <line
            x1="237"
            x2="419.999"
            y1="233"
            y2="232.501"
            stroke="#00D180"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <line
            x1="237"
            x2="269"
            y1="169"
            y2="169"
            stroke="#FFD302"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <line
            x1=".5"
            x2="75.5"
            y1="97.5"
            y2="97.5"
            stroke="#FFF"
            strokeLinecap="square"
            strokeWidth="4"
          />
        </g>
        <g transform="translate(0 310)">
          <use
            fill="#000"
            filter="url(#appdynamics-node-insights-Z)"
            xlinkHref="#appdynamics-node-insights-aa"
          />
          <use fill="#F7FBFB" xlinkHref="#appdynamics-node-insights-aa" />
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="21" y="31">
              Transaction Scorecard
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="21" y="61">
              Normal
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="195.982" y="61">
              97%
            </tspan>
          </text>
          <line
            x1="88"
            x2="182"
            y1="57"
            y2="57"
            stroke="#00D180"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="21" y="81">
              Slow
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="202.656" y="81">
              1%
            </tspan>
          </text>
          <line
            x1="88"
            x2="95"
            y1="77"
            y2="77"
            stroke="#FFD300"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="21" y="101">
              Very Slow
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="192.648" y="101">
              0.2%
            </tspan>
          </text>
          <line
            x1="88"
            x2="91"
            y1="97"
            y2="97"
            stroke="#FF7E32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="21" y="121">
              Stall
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="21" y="141">
              Errors
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="202.656" y="121">
              0%
            </tspan>
          </text>
          <text fill="#172A3F" fontFamily="ArialMT, Arial" fontSize="12">
            <tspan x="192.648" y="141">
              1.6%
            </tspan>
          </text>
          <line
            x1="88"
            x2="89"
            y1="117"
            y2="117"
            stroke="#FF66FA"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <line
            x1="88"
            x2="91"
            y1="137"
            y2="137"
            stroke="#FF1F2F"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
          />
          <line
            x1="88"
            x2="182"
            y1="57"
            y2="57"
            stroke="#00D180"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-ab)"
            opacity=".593"
          />
          <line
            x1="88"
            x2="95"
            y1="77"
            y2="77"
            stroke="#FFD300"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-ac)"
            opacity=".593"
          />
          <line
            x1="88"
            x2="91"
            y1="97"
            y2="97"
            stroke="#FF7E32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-ad)"
            opacity=".593"
          />
          <line
            x1="88"
            x2="89"
            y1="117"
            y2="117"
            stroke="#FF66FA"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-ae)"
            opacity=".593"
          />
          <line
            x1="88"
            x2="91"
            y1="137"
            y2="137"
            stroke="#FF1F2F"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="8"
            filter="url(#appdynamics-node-insights-af)"
            opacity=".593"
          />
        </g>
      </g>
    </svg>
  </div>
)

NodeInsights.defaultProps = {
  className: '',
  classNames: {
    container: 'container',
  },
}

NodeInsights.propTypes = {
  className: PropTypes.string,
  classNames: PropTypes.shape({
    container: PropTypes.string,
  }),
}

export default NodeInsights
